var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "mapa_canteiro_foam" }, [
      _c("div", {
        staticStyle: { height: "900px" },
        attrs: { id: "visualizationTree" }
      })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }